import { BooleanField, Show, SimpleShowLayout, TextField } from "react-admin";
export function AppSettingsShow() {
  return (
    <Show>
      <SimpleShowLayout>
        <TextField source="id" label="ID" />
        <TextField source="name" />
        {/* <TextField source="key" /> */}
        <TextField source="value" />
        <BooleanField source="isPublic" />
        <TextField source="description" />
      </SimpleShowLayout>
    </Show>
  );
}
